<template>
  <b-modal
    id="RelancerFeedback"
    ok-only
    ok-title="Submit feedback"
    no-stacking
    centered
    ok-variant="primary"
    @ok.prevent="submit"
  >
    <b-form v-if="match.id">
      <b-row>
        <b-col>
          <label class="h7 mb-3">
            Feedback for Relancer
          </label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label class="mb-3 h9">
            How likely is it that you recommend Relancer to a friend or colleague?
          </label>
          <span class="text-primary">*</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-radio-group
              v-model="score"
              :options="emojis"
              buttons
              button-variant="emoji"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- <b-row class="mb-4">
      <b-col class="d-inline-flex">
        <b-col
          class="text-left h9"
          style="color: #F7625B;"
        >
          Not at all likely
        </b-col>
        <b-col
          class="text-right h9"
          style="color: #00A725;"
        >
          Extremely likely
        </b-col>
      </b-col>
    </b-row> -->
      <b-row>
        <b-col>
          <label class="mb-3 h9 pl-3 pr-3">
            Would you please describe in 2-3 sentences what was positive and what could be improved in Relancer’s process, service, or platform?
          </label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea
            v-model="feedback"
            class="modal-feedback h9"
            placeholder="We always welcome a more in-depth feedback, so don’t hold back! Relancer is always striving to get better. "
            rows="6"
          />
        </b-col>
      </b-row>
      <b-row class="text-left ml-4">
        <b-col class="ml-2">
          <b-form-checkbox
            v-model="testimonialAgreed"
            class="d-inline"
            :value="true"
            :unchecked-value="false"
            required
          >
            <small class="h9 pb-1">
              If you’re happy with Relancer’s service, could you please give us a testimonial?

            </small>
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="testimonialAgreed">
        <b-col>
          <b-form-textarea
            v-model="testimonial"
            class="modal-feedback h9"
            placeholder="Some questions to consider:
- What problems did we help you to solve?
- What about our service surprised you the most?
- What's the main reason you recommend our service?"
            rows="6"
          />
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import axios from '@/helpers/cleanAxios'

export default {
  name: 'RelancerFeedback',
  data () {
    return {
      match: {},
      score: null,
      feedback: '',
      testimonialAgreed: false,
      testimonial: '',
      emojis: [
        { text: '😓', value: 1 },
        { text: '🙁', value: 2 },
        { text: '🙄', value: 3 },
        { text: '🙂', value: 4 },
        { text: '😍', value: 5 },
      ],
    }
  },
  created () {
    if ((new URLSearchParams(window.location.search)).get('feedback-relancer')) {
      axios.get(`/v2/matches/${(new URLSearchParams(window.location.search)).get('feedback-relancer')}`)
        .then(({ data }) => {
          this.match = data
        })
    }
  },
  methods: {
    submit () {
      axios.post('/v2/feedbacks', {
        for: 'relancer',
        score: this.score,
        feedback: this.feedback,
        testimonial: this.testimonial,
        matchId: this.match.id,
      })
        .then(() => {
          this.$bvModal.hide('RelancerFeedback')
        })
        .then(() => {
          this.$bvModal.msgBoxOk('We really value your feedback as it helps us improve Relancer experience in the future for you and others. Together we can create the best recruitment community in the world. 💪🏼', {
            title: 'Thank you!',
            size: 'md',
            buttonSize: 'lg',
            headerClass: 'p-2 justify-content-center',
            centered: true,

          })
            .then(() => {
              this.$router.push('/')
            })
        })
        .catch((error) => {
          this.$bvToast.toast('Please answer all required fields', {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 3000,
            solid: true,
          })
          throw error
        })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
